// src/components/settings/shared/SettingsTableElements.tsx
import React from 'react';
import {
  Box,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '../../../theme/themeTypes';

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  overflowX: 'auto',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  '& .MuiTableCell-head': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : colors.tertiary.main,
    fontWeight: 700,
    fontSize: '1.5rem',
    whiteSpace: 'nowrap',
  },
}));

export const StyledTableHeaderCell = styled(TableCell)({});

export const StyledTableBody = styled(TableBody)({});

interface StyledTableRowProps {
  isOdd?: boolean;
}

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'isOdd',
})<StyledTableRowProps>(({ theme, isOdd }) => {
  const isDark = theme.palette.mode === 'dark';
  const alternatingRows = (theme.palette as any).alternatingRows;

  const backgroundColor = isOdd
    ? isDark
      ? alternatingRows.darkOdd
      : alternatingRows.lightOdd
    : isDark
      ? alternatingRows.darkEven
      : alternatingRows.lightEven;

  return {
    backgroundColor,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  };
});

export const StyledTableCell = styled(TableCell)({
  '&:not(.MuiTableCell-head)': {
    whiteSpace: 'nowrap',
    '& p': { fontSize: '1.8rem', fontWeight: '600' },
  },
});

export const StyledTableCellWithIcon = styled(TableCell)({
  '&:not(.MuiTableCell-head)': {
    whiteSpace: 'nowrap',
    '& div': {
      display: 'flex',
      alignItems: 'center',
    },
    '& p': { fontSize: '2rem', fontWeight: '600' },
    '& svg': { fontSize: '2rem' },
  },
});

export const StyledTableChipCell = styled(TableCell)({
  '&:not(.MuiTableCell-head)': {
    whiteSpace: 'nowrap',
    padding: 0,
  },
});

export const StyledTableChipCellContent = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
});

export const StyledTableActionsCell = styled(TableCell)({
  '&:not(.MuiTableCell-head)': {
    whiteSpace: 'nowrap',
    padding: 0,
  },
});

export const AccordionButtonLabel = styled(Box)({
  '&:not(.MuiTableCell-head)': {
    whiteSpace: 'nowrap',
    '& p': { fontSize: '2rem', fontWeight: '600' },
  },
});
